module.exports = self["window"]["_rm3_shared"]["@rm3/lib/feature-flags/FeatureFlagsUserClient"];